/** Locale code whose connected script requires whole-word motion wrappers. */
export const ARABIC_LOCALE = 'ar' as const;
